import {request} from '@/helpers/apiClient'
import {SEGMENTS_CONFIG} from '@/utils/constants/apiConfig/segmentsConfig'

// Get segment groups with optional search
export const getSegmentGroups = (searchQuery = '') => {
  return request(SEGMENTS_CONFIG.SEGMENTS_LIST(searchQuery))
}

// export const getSegmentsByGroupId = (groupId = '') => {
//   return request(SEGMENTS_CONFIG.SEGMENTS_BY_GROUP(groupId))
// }

// Get segments with pagination (without group filtering)
export const getSegments = (page = 1, pageSize = 10) => {
  // Convert from 1-based pagination (UI) to 0-based pagination (API)
  const apiPage = Math.max(0, page - 1)

  const queryParams = new URLSearchParams({
    page: String(apiPage),
    pageSize: String(pageSize),
  })

  const config = {
    ...SEGMENTS_CONFIG.SEGMENTS_BASE,
    endPoint: `${SEGMENTS_CONFIG.SEGMENTS_BASE.endPoint}?${queryParams.toString()}`,
  }
  return request(config)
}

// Helper to build query string
const buildQueryParams = (page, pageSize, search = '') => {
  const query = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  })

  if (search && search.trim() !== '') {
    query.append('search', search.trim())
  }

  return query.toString()
}

// Get segments by group ID with pagination and search
export const getSegmentsByGroupId = (segmentGroupId, page = 0, pageSize = 10, search = '') => {
  const queryParams = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
    groupId: segmentGroupId,
  })

  if (search && search.trim() !== '') {
    queryParams.append('search', search.trim())
  }

  const config = {
    ...SEGMENTS_CONFIG.SEGMENTS_BASE,
    endPoint: `${SEGMENTS_CONFIG.SEGMENTS_BASE.endPoint}?${queryParams.toString()}`,
  }
  return request(config)
}

// Get all segments without group filtering
export const getAllSegments = (page = 0, pageSize = 10, search = '') => {
  const queryParams = buildQueryParams(page, pageSize, search)

  const config = {
    ...SEGMENTS_CONFIG.SEGMENTS_BASE,
    endPoint: `${SEGMENTS_CONFIG.SEGMENTS_BASE.endPoint}?${queryParams}`,
  }
  return request(config)
}
